import ReviewQueueMetric from './ReviewQueueMetric'

export default ReviewQueueMetric
